// extracted by mini-css-extract-plugin
module.exports = {"pastEvent":"EventCard__past-event--iWomXoEG"};